import { Box, Button, Container, Stack, Typography } from '@mui/material';
import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error boundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return <>{this.props.fallback}</>;
      }

      return (
        <Container>
          <Stack
            className="error-boundary"
            sx={{
              pt: 4,
              maxWidth: 'sm',
              mx: 'auto',
              textAlign: 'center',
              gap: 1,
            }}
          >
            <Typography variant="h1">Na stránce došlo k chybě.</Typography>

            <Typography variant="h4">Zkuste stránku obnovit.</Typography>

            <Box sx={{ mt: 2 }}>
              <Button
                variant="contained"
                onClick={() => (window.location.href = '/')}
              >
                Obnovit stránku
              </Button>
            </Box>
          </Stack>
        </Container>
      );
    }

    return <>{this.props.children}</>;
  }
}
